/**
 * Edge Configuration Constants
 *
 * Centralized configuration for CustomTransitionEdge styling and behavior.
 * Controls edge colors, button size, and interaction states.
 *
 * Sprint: sprint-4
 * Related: FR-010 (Edge click interaction)
 */

/**
 * Edge button dimensions (px)
 *
 * BUTTON_SIZE: Circular button in the middle of edge
 */
export const EDGE_BUTTON = {
  SIZE: 15, // Half of original 30px
  BORDER_WIDTH: 2,
} as const;

/**
 * Edge stroke widths based on state (px)
 */
export const EDGE_STROKE_WIDTH = {
  DEFAULT: 1,      // Reduced by 2x (was 2)
  HOVERED: 1.25,   // Reduced by 2x (was 2.5)
  SELECTED: 1.5,   // Reduced by 2x (was 3)
} as const;

/**
 * Edge path configuration
 */
export const EDGE_PATH = {
  BORDER_RADIUS: 10, // Smooth corners for getSmoothStepPath
  CLICK_TARGET_WIDTH: 10, // Invisible wider path for easier clicking
} as const;

// Type exports for TypeScript inference
export type EdgeButtonSize = typeof EDGE_BUTTON[keyof typeof EDGE_BUTTON];
export type EdgeStrokeWidth = typeof EDGE_STROKE_WIDTH[keyof typeof EDGE_STROKE_WIDTH];
